// src/features/tenants/hooks/useDeactivateTenant.ts
//
// Submission seam for the "غیرفعال‌سازی تننت" flow.
// Owns loading/error state around deactivateTenant API call.
// Same shape as useSuspendTenant — no existing UI slot was found to
// wire this into (TenantWorkspaceHeader only has suspend/delete
// actions today), so this hook is intentionally not yet connected to
// any button; see the implementation report for details.

import { useState } from 'react';

import { deactivateTenant } from '../api/tenants.api';

export function useDeactivateTenant() {
  const [deactivating, setDeactivating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(id: string) {
    setDeactivating(true);
    setError(null);

    try {
      const tenant = await deactivateTenant(id);
      return tenant;
    } catch (err) {
      setError('خطا در غیرفعال‌سازی تننت. لطفاً دوباره تلاش کنید.');
      throw err;
    } finally {
      setDeactivating(false);
    }
  }

  function resetError() {
    setError(null);
  }

  return {
    submit,
    deactivating,
    error,
    resetError,
  };
}
